<template>
  <div class="plv-ia-question-bank">
    <div class="plv-ia-question-bank-list">
      <div class="plv-ia-question-bank-list__wrap">
        <table>
          <thead>
            <tr>
              <th width="50%">{{ t('plvIA.answerCard.bankName') }}</th>
              <th width="15%">{{ t('plvIA.answerCard.bankStatus') }}</th>
              <th width="35%">{{ t('plvIA.answerCard.operation') }}</th>
            </tr>
          </thead>
          <tbody class="plv-ia-question-bank-list-tbody">
            <tr
              v-for="item in list"
              :key="item.templateId"
              class="plv-ia-question-bank-list-row"
            >
              <td>{{ item.name }}</td>
              <td>{{ getStatus(item.status) }}</td>
              <td class="plv-ia-question-bank-operation">
                <template v-if="item.status !== 'error'">
                  <span @click="handleImport(item.templateId)">{{ t('plvIA.answerCard.apply') }}</span>
                  <span @click="handleDownload(item.templateId)">{{ t('plvIA.answerCard.download') }}</span>
                </template>
                <span v-else @click="handleUpload(true)">{{ t('plvIA.answerCard.reupload') }}</span>

                <span @click="handleDelete(item)">{{ t('plvIA.common.delete') }}</span>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="!list || list.length === 0" class="plv-ia-question-bank-nocontent">{{ t('plvIA.answerCard.noContent') }}</div>
      </div>
    </div>

    <div class="plv-ia-question-bank-bottom">
      <button class="plv-ia-btn-new plv-ia-btn-blue" @click="handleUpload(false)">{{ t('plvIA.answerCard.uploadBank') }}</button>
      <button class="plv-ia-btn-new" @click="handleDownload('')">{{ t('plvIA.answerCard.downloadTemplate') }}</button>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';

export default {
  mixins: [Locale],
  props: {
    list: {
      type: Array,
      default: () => []
    },
  },

  methods: {
    getStatus(key) {
      return {
        used: this.t('plvIA.answerCard.inUsingStatus'),
        unused: this.t('plvIA.answerCard.notUsedStatus'),
        error: this.t('plvIA.answerCard.templateErr'),
      }[key] || this.t('plvIA.common.undefinedError');
    },

    handleImport(templateId) {
      this.$emit('import', templateId);
    },

    handleDelete(data) {
      const { templateId, status, isDefault } = data;
      if (isDefault) {
        this.$iaMessage.default(this.t('plvIA.answerCard.defaultCantDelTips'));
        return;
      }
      if (status === 'used') {
        this.$iaMessage.default(this.t('plvIA.answerCard.bankUsingCantDelTips'));
        return;
      }
      this.$emit('delete', templateId);
    },

    handleUpload(isReupload = false) {
      this.$emit('upload', isReupload);
    },

    handleDownload(templateId) {
      this.$emit('download', templateId);
    },
  }
};
</script>

<style lang="scss" scoped>
$blue: #0A8DFF;

.plv-ia-question-bank {
  height: 100%;
  font-size: 14px;
  position: relative;
}

.plv-ia-question-bank-list {
  height: 100%;
  padding-bottom: 80px;
  box-sizing: border-box;

  table {
    width: 100%;
    border-collapse: collapse;
  }

  thead {
    background: #EDF1F7;
    border-bottom: 1px solid #CFD8DC;
  }

  th, td {
    line-height: 48px;
    text-align: center;
  }

  th {
    font-weight: normal;
    color: #333;
  }

  td {
    color: #546E7A;

    &:first-child {
      max-width: 400px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 20px;
      box-sizing: border-box;
    }
  }

  tbody tr {
    &:nth-child(odd) {
      background: #fff;
    }

    &:nth-child(even) {
      background: #F8F8FB;
    }
  }
}

.plv-ia-question-bank-list__wrap {
  height: 100%;
  overflow: auto;
  padding: 20px 16px;
  box-sizing: border-box;
}

.plv-ia-question-bank-operation {
  >* {
    color: $blue;
    text-decoration: none;
    margin: 0 5px;
    cursor: pointer;

    &:hover {
      color: rgba($color: $blue, $alpha: 0.8);
    }

    &:active {
      color: rgba($color: $blue, $alpha: 0.9);
    }
  }
}

.plv-ia-question-bank-bottom {
  position: absolute;
  width: 100%;
  height: 80px;
  bottom: 0;
  left: 0;
  text-align: center;

  .plv-ia-btn-new {
    margin: 24px 8px 0;
  }
}

.plv-ia-question-bank-nocontent {
  padding: 40px 0;
  text-align: center;
  color: #546E7A;
}
</style>
